/* eslint-disable no-unused-vars */
import React, {Component} from "react";
import {FormControlLabel, TextField, InputLabel, NativeSelect, withStyles, Select, MenuItem} from "@material-ui/core";
import classNames from 'classnames';
import FormControl from '@material-ui/core/FormControl';
import Util from "../../../yeffect/utils";

const styles = theme => ({
    input: {
        width: '100%',
    },
    wrapper:{
        paddingLeft:'8px',
        paddingRight:'8px'
    }
});

class SelectInput extends Component {
    state = {
        active:     this.props.active || 1
    }

    render() {
        const { classes, possibleValues, value, width, onChange, fieldLabel, fieldName, errorFields} = this.props;
        const { active } = this.state;

        return (
            <React.Fragment>
                <div className={classNames(classes.wrapper,width)}>

                    <FormControl className={classNames('w-full')} >
                        <InputLabel shrink={(!Util.isEmpty(value) || value === false || value === 0)} id={fieldName + '_label'}>{fieldLabel} {(this.props.required === true) ? '*' :''}</InputLabel>
                        <Select
                            labelId={fieldName + '_label'}
                            id={fieldName}
                            value={value}
                            label="Age"
                            name={fieldName}
                            onChange={onChange}
                            error={!(typeof errorFields[fieldName] === "undefined")}
                            helperText={(typeof errorFields[fieldName] !== "undefined") ? errorFields[fieldName] : false}
                            required={this.props.required}
                            >


                            <option value=""> </option>
                            {possibleValues.map(o => {
                                return (
                                <MenuItem value={o.value}>{o.label}</MenuItem>
                                )

                            })}
                        </Select>
                    </FormControl>

                </div>
            </React.Fragment>
        );
    }
}

export default withStyles(styles, { withTheme: true })(SelectInput);


// WEBPACK FOOTER //
// ./src/yeffect/formBuilder/components/SelectInput.js